import { ProType } from "../pro/pro.service";

export class Company {
    id: number;
    name: string;
    proType: 'PENDING' | 'TRIAL' | 'NOT_PRO' | 'REQUESTED' | 'TRIAL_PRO';
    email?: string
}

export type ReportContactResponse = {
    result: 'SUCCESS' | 'FAILED';
} & ReportContact;

export interface ReportContact {
    reportLogo: string;
    reportContactEmail: string;
    reportContactPhone: string;
}

export interface CompaniesResponse {
    companies: Company[];
}

export interface ReportStatisticsResponse {
    downloadedReportNr: number;
    createdReportNr: number;
    deletedReportNr: number;
    nrOfDrivers: number;
}

export interface ReportFile {
    id: number;
    fileHash: string;
    fileName: string;
    timestamp: number;
    clientId: number;
    userId: number;
    deleted: boolean;
    reportType: number;
    downloaded: boolean;
    ipAddress: string;
    driverId: number;
}

export interface ReportFilesReponse {
    result: string;
    files: ReportFile[];
}

export enum TypeOfAccount {
    NORMAL = 0,
    TEST = 1,
    SELF_ONLY = 2
}

export interface CompanyFlagsResponse {
    companyFlags: Flags;
    result: string;
    PROType: ProType;
    typeOfAccount: TypeOfAccount;
    processCorruptedFiles: boolean;
    hasTerminalsToReplace?: boolean;
}

export interface Flags {
    expenseClient: boolean,
    nfcClient: boolean,
    connectedClient: boolean,
    uploaderClient: boolean,
    analyserClient: boolean
    proClient: boolean
    clientId: number
}

export type EmailNotificationType =
    | 'FILE_UPLOAD'
    | 'BEFORE_DRIVER_CARD_DOWNLOAD'
    | 'BEFORE_VEHICLE_DOWNLOAD'
    | 'BEFORE_DRIVER_CARD_EXPIRATION'
    | 'BEFORE_PERIODIC_INSPECTION';

export interface EmailNotification {
    notificationType: EmailNotificationType;
    daysBeforeSend: number;
}

export interface EmailNotificationSettingsResponse {
    result: string;
    message: string;
    data: {
        clientNotificationSettings: EmailNotification[];
    };
}

export interface CompanyInfo {
    clientId: number;
    clientName: string;
    managerName: string | null;
    address: string;
    city: string;
    country: string;
    vat: string;
    registrationNumber: string;
    contact: string;
    phone: string;
    fax: string;
    site: string;
    email: string;
}

export interface CompanyInfoResponse {
    result: string;
    message?: string;
    company: CompanyInfo;
}

export type CompanyInfoUpdateRequest = Pick<
    CompanyInfo,
    'clientId' | 'address' | 'city' | 'country' | 'vat' | 'registrationNumber' | 'contact' | 'phone' | 'fax' | 'site' | 'email'
>;

